export enum WordCloudType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export class Cloud {
  count: number;
  text: string;
  constructor(json: any) {
    this.count = json.count;
    this.text = json.text;
  }
}

export class WordCloudData {
  reccoId: string;
  cloud: Cloud[];
  type: WordCloudType;

  constructor(json: any) {
    this.reccoId = json.reccoId;
    this.cloud = json.cloud?.map((cloud: any) => new Cloud(cloud));
    this.type = json.type;
  }
}
